import { useLayoutEffect } from 'react';
import { useLocation } from 'react-router-dom';

const RouteScrollReset = () => {
  const { key } = useLocation();

  useLayoutEffect(() => {
    const previousRestoration = window.history.scrollRestoration;
    window.history.scrollRestoration = 'manual';

    return () => {
      window.history.scrollRestoration = previousRestoration;
    };
  }, []);

  useLayoutEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
  }, [key]);

  return null;
};

export default RouteScrollReset;
